import * as React from "react";

const MsGraphApiIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    {...props}
  >
    <defs>
      <path
        id="a"
        d="M34.9 3.2H13.1c-.7 0-1.4.4-1.8 1L.5 23c-.4.6-.4 1.4 0 2.1l10.9 18.7c.4.6 1.1 1 1.8 1h21.7c.7 0 1.4-.4 1.8-1L47.5 25c.4-.6.4-1.4 0-2.1L36.7 4.3c-.4-.7-1.1-1.1-1.8-1.1z"
      />
    </defs>
    <clipPath id="b">
      <use xlinkHref="#a" style={{ overflow: 'visible' }} />
    </clipPath>
    <g clipPath="url(#b)">
      <path fill="#28A8EA" d="m11.3 3.1 4.3 8L35.4 3.1z" />
      <path fill="#0078D4" d="m11.3 3.1 4.3 8L.2 23.3V3.1z" />
      <path fill="#0364B8" d="m-.8 24 16.4-12.9.9 26z" />
      <path fill="#14447D" d="m-.8 24 17.3 13.1-5 7.7-11.3.4z" />
      <path fill="#0F335E" d="m11.5 44.8 5-7.7 19.7 8.1z" />
      <path fill="#0364B8" d="m16.5 37.1 20.2-13.1-.5 21.2z" />
      <path fill="#28A8EA" d="m16.5 37.1-1-26 21.2 12.9z" />
      <path fill="#50D9FF" d="m15.6 11.1 20.6-8.3.5 21.2z" />
      <path fill="#28A8EA" d="m36.7 24-.5-21.2 11.9.3V24z" />
      <path fill="#0078D4" d="m36.7 24-.5 21.9 11.3-.1.6-21.8z" />
    </g>
  </svg>
);

export default MsGraphApiIcon;
